<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="page_ix"></a>CONTENTS</h2>
<p class="toc-entryi"><a href="#/xhtml/frontmatter01"><em>Preface</em></a></p>
<p class="toc-entryi"><a href="#/xhtml/frontmatter02"><em>Acknowledgments</em></a></p>
<p class="toc-entryi"><a href="#/xhtml/frontmatter03"><em>Note on Film Titles</em></a></p>
<p class="toc-entry1"><a href="#/xhtml/part01"><span class="small">PART 1 TOWARD A PERFORMATIVE THEORY OF EURO HORROR CINEMA</span></a></p>
<p class="toc-entry"><a href="#/xhtml/chapter01">1 Academic Hot Spots and Blind Spots:<br/>Horror Film Studies and Euro Horror Cinema</a></p>
<p class="toc-entry"><span href="#/xhtml/chapter02" title="Link target outside of Sample">2 Fast, Cheap, and Out of Control:<br/>The Academic Case against Euro Horror Cinema</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter03" title="Link target outside of Sample">3 Playing Dead, Take One:<br/>Euro Horror Film Production</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter04" title="Link target outside of Sample">4 Playing Dead, Take Two:<br/>Euro Horror Film Reception</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter05" title="Link target outside of Sample">5 Return of the Repressed:<br/>Euro Horror Cinema in Contemporary American Culture</span></p>
<p class="toc-entry1"><a id="page_x"></a><span href="#/xhtml/part02" title="Link target outside of Sample"><span class="small">PART 2 CASE STUDIES IN EURO HORROR CINEMA</span></span></p>
<p class="toc-entry"><span href="#/xhtml/chapter06" title="Link target outside of Sample">6 Blood and Black Lace:<br/>The <em>Giallo</em> Film</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter07" title="Link target outside of Sample">7 The Whip and the Body:<br/>The S&amp;M Horror Film</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter08" title="Link target outside of Sample">8 Cannibal Apocalypse:<br/>Cannibal and Zombie Films</span></p>
<p class="toc-entry1"><span href="#/xhtml/backmatter01" title="Link target outside of Sample"><span class="small">CONCLUSION</span> From the Grindhouse to the Arthouse: The Legacy of Euro Horror Cinema</span></p>
<p class="toc-entryi"><span href="#/xhtml/backmatter02" title="Link target outside of Sample"><em>Works Cited</em></span></p>
<p class="toc-entryi"><span href="#/xhtml/backmatter03" title="Link target outside of Sample"><em>Index</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?f0bc499a